module.exports = "<div class=center> <div class=logo> <div class=logo-container></div> </div> <div class=container> <div class=progress> </div> </div> </div> ";